import styled from 'styled-components';
import tw from 'twin.macro';

const Container = styled.div`
  ${tw``}
`;

const Section = styled.div`
  ${tw`flex flex-col gap-4`}
`;

const SubSection = styled.div`
  ${tw`border border-gray-600 border-solid p-4`}
`;

const Title = styled.div`
  ${tw`font-bold mb-4 uppercase`}
`;

const SubTitle = styled.div`
  ${tw`font-bold mb-2`}
`;

const Text = styled.div`
  ${tw`text-sm mb-4`}
`;

const NoticeBox = styled.div`
  ${tw`bg-gray-100 p-4 mb-4 border border-gray-600 max-w-full min-w-0 box-border`}
`;

const OtherComponentPageThree = () => {
  return (
    <Container>
      <Section>
        <SubSection>
          <SubTitle>Seller's Right to Cancel</SubTitle>
          <Text>
            a. Seller agrees to deliver the vehicle to you on the date this contract is signed by
            Seller and you. You understand that it may take some time for Seller to verify your
            credit and assign the contract. You agree that if Seller is unable to assign the
            contract to any one of the financial institutions with whom Seller regularly does
            business under terms acceptable to Seller, Seller may cancel the contract.
          </Text>
          <Text>
            b. Seller shall give you written notice (or in any other manner in which actual notice
            is given to you) within 10 days of the date of this contract is signed if Seller elects
            to cancel. Upon receipt of such notice, you must immediately return the vehicle to
            Seller in the same condition as when sold, reasonable wear and tear excepted. Seller
            must give back to you all consideration received by Seller, including any trade-in
            vehicle.
          </Text>
          <Text>
            c. If you do not immediately return the vehicle, you will be liable for all expenses
            incurred by Seller in taking the vehicle from you, including reasonable attorney's fees.
          </Text>
          <Text>
            d. While the vehicle is in your possession, all terms of the contract, including those
            relating to use of the vehicle and insurance for the vehicle, shall be in full force and
            you shall assume all risk of loss or damage to the vehicle. You must pay all reasonable
            costs for repair of any damage to the vehicle and the vehicle shall be subject to a lien
            for such costs.
          </Text>
        </SubSection>
        <SubSection>
          <Title>ARBITRATION PROVISION</Title>
          <Text className="uppercase font-bold">
            PLEASE REVIEW - IMPORTANT - AFFECTS YOUR LEGAL RIGHTS
          </Text>
          <Text>
            1. EITHER YOU OR WE MAY CHOOSE TO HAVE ANY DISPUTE BETWEEN YOU AND US DECIDED BY
            ARBITRATION AND NOT IN COURT OR BY JURY TRIAL.
          </Text>
          <Text>
            2. IF A DISPUTE IS ARBITRATED, YOU WILL GIVE UP YOUR RIGHT TO PARTICIPATE AS A CLASS
            REPRESENTATIVE OR CLASS MEMBER ON ANY CLASS CLAIM YOU MAY HAVE AGAINST US INCLUDING ANY
            RIGHT TO CLASS ARBITRATION OR ANY CONSOLIDATION OF INDIVIDUAL ARBITRATIONS.
          </Text>
          <Text>
            3. DISCOVERY AND RIGHTS TO APPEAL IN ARBITRATION ARE GENERALLY MORE LIMITED THAN IN A
            LAWSUIT, AND OTHER RIGHTS THAT YOU AND WE WOULD HAVE IN COURT MAY NOT BE AVAILABLE IN
            ARBITRATION.
          </Text>
          <Text>
            Any claim or dispute, whether in contract, tort, statute or otherwise (including the
            interpretation and scope of this Arbitration Provision, and the arbitrability of the
            claim or dispute), between you and us or our employees, agents, successors or assigns,
            which arises out of or relates to your credit application, purchase or condition of this
            vehicle, this contract or any resulting transaction or relationship (including any such
            relationship with third parties who do not sign this contract) shall, at your or our
            election, be resolved by neutral, binding arbitration and not by a court action. If
            federal law provides that a claim or dispute is not subject to binding arbitration, this
            Arbitration Provision shall not apply to such claim or dispute. Any claim or dispute is
            to be arbitrated by a single arbitrator on an individual basis and not as a class
            action. You expressly waive any right you may have to arbitrate a class action. You may
            choose the American Arbitration Association (www.adr.org), or any other organization to
            conduct the arbitration subject to our approval. You may get a copy of the rules of an
            arbitration organization by contacting the organization or visiting its website.
          </Text>
          <Text>
            Arbitrators shall be attorneys or retired judges and shall be selected pursuant to the
            applicable rules. The arbitrator shall apply governing substantive law and the
            applicable statute of limitations. The arbitration hearing shall be conducted in the
            federal district where you reside unless the Seller-Creditor is a party to the claim or
            dispute, in which case the hearing will be held in the federal district where this
            contract was executed. We will pay your filing, administration, service or case
            management fee and your arbitrator or hearing fee all up to a maximum of $5,000, unless
            the law or the rules of the chosen arbitration organization require us to pay more. The
            amount we pay may be reimbursed in whole or in part by decision of the arbitrator if the
            arbitrator finds that any of your claims is frivolous under applicable law. Each party
            shall be responsible for its own attorney, expert and other fees, unless awarded by the
            arbitrator under applicable law. If the chosen arbitration organization's rules conflict
            with this Arbitration Provision, then the provisions of this Arbitration Provision shall
            control. Any arbitration under this Arbitration Provision shall be governed by the
            Federal Arbitration Act (9 U.S.C. § 1 et seq.) and not by any state law concerning
            arbitration. Any award by the arbitrator shall be in writing and will be final and
            binding on all parties, subject to any limited right to appeal under the Federal
            Arbitration Act.
          </Text>
          <Text>
            You and we retain any rights to self-help remedies, such as repossession. You and we
            retain the right to seek remedies in small claims court for disputes or claims within
            that court's jurisdiction, unless such action is transferred, removed or appealed to a
            different court. Neither you nor we waive the right to arbitrate by filing any action in
            small claims court, or by filing an action to recover the vehicle, to recover a
            deficiency balance, or for individual injunctive relief. Any court having jurisdiction
            may enter judgment on the arbitrator's award. This Arbitration Provision shall survive
            any termination, payoff or transfer of this contract. If any part of this Arbitration
            Provision, other than waivers of class action rights, is deemed or found to be
            unenforceable for any reason, the remainder shall remain enforceable. If a waiver of
            class action rights is deemed or found to be unenforceable for any reason in a case in
            which class action allegations have been made, the remainder of this Arbitration
            Provision shall be unenforceable.
          </Text>

          <NoticeBox>
            NOTICE - ANY HOLDER OF THIS CONSUMER CREDIT CONTRACT IS SUBJECT TO ALL CLAIMS AND
            DEFENSES WHICH THE DEBTOR COULD ASSERT AGAINST THE SELLER OF GOODS OR SERVICES OBTAINED
            PURSUANT HERETO OR WITH THE PROCEEDS HEREOF. RECOVERY HEREUNDER BY THE DEBTOR SHALL NOT
            EXCEED AMOUNTS PAID BY THE DEBTOR HEREUNDER.
          </NoticeBox>
          <Text>
            The preceding NOTICE applies only to goods or services obtained primarily for personal,
            family or household use. In all other cases, Buyer will not assert against any
            subsequent holder or assignee of this contract any claims or defenses the Buyer (debtor)
            may have against the Seller, or against the manufacturer of the vehicle or equipment
            obtained under this contract.
          </Text>
        </SubSection>
      </Section>
    </Container>
  );
};

export default OtherComponentPageThree;
